import {
  HIVE_SCROLL_ANCHORING_WIDGET,
  HiveScrollAnchoringWidget,
} from './scroll-anchoring.js';

export function effects() {
  customElements.define(
    HIVE_SCROLL_ANCHORING_WIDGET,
    HiveScrollAnchoringWidget
  );
}

declare global {
  interface HTMLElementTagNameMap {
    [HIVE_SCROLL_ANCHORING_WIDGET]: HiveScrollAnchoringWidget;
  }
}
